import { useFeatureFlags } from 'src/context';

/**
 * The plans page's outer stack, shared with its loading skeleton. The old
 * settings shell hides this page's title, so the page pads itself; the
 * new-settings column has its own header and spacing.
 */
export const usePlansPageClassName = () => {
  const { EnableNewSettings } = useFeatureFlags();
  return EnableNewSettings
    ? 'flex flex-col gap-12'
    : 'flex flex-col gap-12 pb-10 pt-10';
};
